<template>
  <div class="banner-wrap">
    <div class="banner-image-wrapper">
      <img :src="ban" alt="banner" class="banner-image" loading="lazy"/>
      <div class="banner-overlay" v-if="$route.path === '/people'"></div>
    </div>
    <!-- 仅人才招聘路由显示文字区域 -->
    <div class="banner-content" v-if="$route.path === '/people'">
      <h1 class="banner-title">加入我们，共创未来</h1>
      <p class="banner-subtitle">JOIN US & CREATE THE FUTURE</p>
      <div class="banner-divider"></div>
      <p class="banner-description">与优秀的人同行，成就更好的自己</p>
      <button class="banner-btn" @click="goJobArea">立即加入 →</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ban: {
      type: String,
      required: true
    }
  },
  methods: {
    goJobArea() {
      // 向上父组件抛出事件
      this.$emit('scroll-job')
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-wrap {
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.banner-image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  
}

.banner-image {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.8s ease;
  object-fit: cover; 
}

// 优化后的遮罩层
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-image: linear-gradient(to right, rgba(0,0,0,0.65), rgba(0,0,0,0.05)), linear-gradient(to bottom, rgba(0,0,0,0.2), transparent 40%, transparent 60%, rgba(0,0,0,0.18));
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 8%;
  transform: translateY(-50%);
  z-index: 2;
  color: #ffffff;
  max-width: 600px;
  animation: fadeInUp 1.2s ease;

  .banner-title {
    font-size: 56px;
    font-weight: 700;
    margin: 0 0 12px 0;
    letter-spacing: 2px;
    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    
    background: linear-gradient(135deg, #ffffff 0%, #f0e6d0 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .banner-subtitle {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 8px;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 16px 0;
    text-transform: uppercase;
  }

  .banner-divider {
    width: 60px;
    height: 3px;
    background: #2563AF;
    border-radius: 2px;
    margin: 0 0 20px 0;
  }

  .banner-description {
    font-size: 18px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.85);
    margin: 0 0 32px 0;
    line-height: 1.6;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }

  .banner-btn {
    padding: 14px 40px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    background: #2563AF;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.4s ease;
    box-shadow: 0 8px 30px rgba(89, 204, 233, 0.4);
    letter-spacing: 1px;

    &:hover {
      transform: translateY(-3px) scale(1.02);
      box-shadow: 0 12px 40px rgba(100, 191, 233, 0.6);
    }

    &:active {
      transform: translateY(0) scale(0.98);
    }
  }
}

// 动画
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(-40%) translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateY(0);
  }
}

// 大屏 1565px以上高度800px
@media (min-width: 1565px) {
  .banner-wrap {
    height: 800px;
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .banner-wrap {
    height: 500px;
  }

  .banner-content {
    left: 6%;
    
    .banner-title {
      font-size: 44px;
    }
  }
}

@media (max-width: 768px) {
  .banner-wrap {
    height: 420px;
    border-radius: 12px;
  }

  .banner-content {
    left: 5%;
    max-width: 90%;
    
    .banner-title {
      font-size: 32px;
    }
    
    .banner-subtitle {
      font-size: 12px;
      letter-spacing: 5px;
    }
    
    .banner-description {
      font-size: 15px;
    }
    
    .banner-btn {
      padding: 12px 30px;
      font-size: 14px;
    }
  }
}

@media (max-width: 480px) {
  .banner-wrap {
    height: 350px;
    border-radius: 8px;
  }

  .banner-content {
    left: 4%;
    
    .banner-title {
      font-size: 24px;
    }
    
    .banner-subtitle {
      font-size: 10px;
      letter-spacing: 4px;
    }
    
    .banner-description {
      font-size: 13px;
      margin-bottom: 20px;
    }
    
    .banner-btn {
      padding: 10px 24px;
      font-size: 12px;
    }
  }
}
</style>